import React from 'react';
import { Navigate } from 'react-router-dom';

const ChatbotLeads: React.FC = () => <Navigate to="/leads?tab=inbound" replace />;

export default ChatbotLeads;
